import { Modal, Form } from "react-bootstrap";
import CommonButton from "../commonButton";
import withModal from "../withModal";
import InputField from "../form/InputField";

const CommonVerifyModalInner = ({
  onClose,
  fields = [], // [{ label, value, placeholder, disabled }]
  showApprove = false,
  showReject = false,
  approveText = "Approve",
  rejectText = "Reject",
  onApprove,
  onReject,
  imageSrc,
}) => {
  const isPdf = imageSrc?.toLowerCase().endsWith(".pdf");
  const isImage = imageSrc?.match(/\.(jpg|jpeg|png|webp)$/i);

  return (<>
    <Modal.Body>
      {/* Dynamic Fields */}
      {fields.length > 0 && (
        <Form className="grid gap-3 mb-3" onSubmit={(e) => e.preventDefault()}>
          {fields.map((field, index) => (
            <InputField
              key={index}
              className="g-col-12 g-col-md-6"
              label={{ name: field.label }}
              input={{
                type: "text",
                value: field.value,
                placeholder: field.placeholder,
                disabled: field.disabled,
                readOnly: true,
                className: "shadow-none"
              }}
            />
          ))}
        </Form>
      )}
      <div className="verify-modal-content mb-3">
        {isImage && <img src={imageSrc} alt="preview" className="w-100 rounded-3" />}

        {isPdf && (
          <iframe
            src={imageSrc}
            width="100%"
            height="80vh"
            style={{ border: "none" }}
            title="PDF Viewer"
          />
        )}
      </div>


    </Modal.Body>
    {/* Buttons */}
    {showApprove || showReject ?
      <Modal.Footer className="d-flex justify-content-center gap-2">
        {showApprove && (
          <CommonButton
            title={approveText}
            className="px-4"
            variant="success"
            onClick={onApprove}
          />
        )}

        {showReject && (
          <CommonButton
            title={rejectText}
            className="px-4"
            onClick={onReject}
            variant="danger"
          />
        )}
      </Modal.Footer>
      : null}

  </>

  );
};

const CommonVerifyModal = withModal(CommonVerifyModalInner);

export default CommonVerifyModal;
